<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <el-table-column align="center" label="姓名" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="职位" min-width="100" prop="zhiwei"></el-table-column>
          <el-table-column align="center" label="工时" min-width="100" prop="gongshi"></el-table-column>
          <el-table-column align="center" label="前处理装框" min-width="100" prop="zhuangkuang"></el-table-column>
          <el-table-column align="center" label="前处理淋洗" min-width="100" prop="linxi"></el-table-column>
          <el-table-column align="center" label="枪手一线白班" min-width="100" prop="qsbaiban1"></el-table-column>
          <el-table-column align="center" label="枪手一线白班1" min-width="100" prop="qsbaiban11"></el-table-column>
          <el-table-column align="center" label="枪手二线白班" min-width="100" prop="qsbaiban2"></el-table-column>
          <el-table-column align="center" label="枪手二线白班1" min-width="100" prop="qsbaiban21"></el-table-column>
          <el-table-column align="center" label="枪手三线白班" min-width="100" prop="qsbaiban3"></el-table-column>
          <el-table-column align="center" label="枪手三线白班1" min-width="100" prop="qsbaiban31"></el-table-column>
          <el-table-column align="center" label="枪手四线白班" min-width="100" prop="qsbaiban4"></el-table-column>
          <el-table-column align="center" label="枪手四线白班1" min-width="100" prop="qsbaiban41"></el-table-column>
          <el-table-column align="center" label="枪手其他" min-width="100" prop="qsbaiban5"></el-table-column>
          <el-table-column align="center" label="枪手当日合计工资" min-width="100" prop="qsheji"></el-table-column>
          <el-table-column align="center" label="普工一线白班" min-width="100" prop="pgbaiban1"></el-table-column>
          <el-table-column align="center" label="普工一线白班1" min-width="100" prop="pgbaiban11"></el-table-column>
          <el-table-column align="center" label="普工二线白班" min-width="100" prop="pgbaiban2"></el-table-column>
          <el-table-column align="center" label="普工二线白班1" min-width="100" prop="pgbaiban21"></el-table-column>
          <el-table-column align="center" label="普工三线白班" min-width="100" prop="pgbaiban3"></el-table-column>
          <el-table-column align="center" label="普工三线白班1" min-width="100" prop="pgbaiban31"></el-table-column>
          <el-table-column align="center" label="普工四线白班" min-width="100" prop="pgbaiban4"></el-table-column>
          <el-table-column align="center" label="普工四线白班1" min-width="100" prop="pgbaiban41"></el-table-column>
          <el-table-column align="center" label="普工其他" min-width="100" prop="pgbaiban5"></el-table-column>
          <el-table-column align="center" label="普工当日合计工资" min-width="100" prop="pgheji"></el-table-column>
          <el-table-column align="center" label="当日合计工资" min-width="100" prop="dangriheji"></el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
const editFormData = () => {
  return {
    riqi: '',
    renyuan: "",
    zhiwei: "",
    gongzi: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      today: '',
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
        day: this.today.getDate()
      }
      axios.post(this.$host+'/index.php/admin/Gongziexcel/tzgzbExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '涂装工资日报表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    getList() {
      this.listLoading = true
      let data = {
        // page: this.pageNum,
        // num: this.pageSize,
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
        day: this.today.getDate()
      }
      this.$request.post('/index.php/admin/Gongzibiao/tzgzb', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
